var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.31,
    height: 10.048,
    viewBox: "0 0 21.31 10.048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_221",
    "data-name": "Gruppe 221",
    transform: "translate(-0.025 0.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_220",
    "data-name": "Gruppe 220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_58",
    "data-name": "Pfad 58",
    d: "M15.359,10.023a.875.875,0,0,1-.466-1.616l4.342-2.725L16.509,1.341A.876.876,0,0,1,17.961.36c.011.016.021.033.031.05l3.189,5.083A.875.875,0,0,1,20.906,6.7l-5.083,3.19A.867.867,0,0,1,15.359,10.023Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_59",
    "data-name": "Pfad 59",
    d: "M20.44,6.833a.88.88,0,0,1-.3-.055,31.037,31.037,0,0,0-18.957,0,.875.875,0,0,1-.609-1.64,32.739,32.739,0,0,1,20.176,0,.875.875,0,0,1-.306,1.7Z",
    fill: "#141414"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrow);
export default __webpack_public_path__ + "static/media/icon-arrow.2c8d4a69fb9ec63496eb3c73f01b328d.svg";
export { ForwardRef as ReactComponent };